/**
 * VendorAdminPage (P15.1).
 *
 * Mount point for /foundation/admin/vendors. Thin wrapper that
 * hands the `vendorAdapter` to the shared `AdminListView`. Every
 * other entity page in P15.2 / P15.3 mirrors this exactly with
 * its own adapter import.
 */
import { AdminListView } from "./AdminListView";
import { vendorAdapter } from "./vendorAdapter";

export function VendorAdminPage() {
  return <AdminListView adapter={vendorAdapter} />;
}
